<div class="organizacao-switcher" dropdown *ngIf="visivel">
  <button
    type="button"
    class="switcher-trigger"
    dropdownToggle
    [disabled]="trocando"
    [attr.aria-label]="'Organização atual: ' + (organizacaoAtiva?.name || '')"
  >
    <span class="switcher-avatar">
      <span class="switcher-spinner" *ngIf="trocando"></span>
      <ng-container *ngIf="!trocando">{{
        getInitials(organizacaoAtiva?.name)
      }}</ng-container>
    </span>
    <span class="switcher-name">{{ organizacaoAtiva?.name }}</span>
    <i class="material-icons chevron">keyboard_arrow_down</i>
  </button>

  <ul *dropdownMenu class="dropdown-menu switcher-menu">
    <li class="switcher-menu-title">Trocar de organização</li>

    <li *ngFor="let organizacao of organizacoes">
      <button
        type="button"
        class="switcher-menu-item"
        [class.switcher-menu-item--ativa]="isAtiva(organizacao)"
        [disabled]="trocando"
        (click)="trocar(organizacao)"
      >
        <span class="switcher-menu-avatar">{{ getInitials(organizacao?.name) }}</span>

        <span class="switcher-menu-texto">
          <span class="switcher-menu-nome">{{ organizacao?.name }}</span>
          <span class="switcher-menu-etiqueta" *ngIf="organizacao?.padrao">Padrão</span>
        </span>

        <span
          class="switcher-spinner switcher-spinner--linha"
          *ngIf="trocandoParaId === organizacao?.id"
        ></span>
        <i
          class="material-icons check"
          *ngIf="isAtiva(organizacao) && trocandoParaId !== organizacao?.id"
          >check</i
        >
      </button>
    </li>
  </ul>
</div>
